
import { useState, useEffect } from 'react';

export const useVoiceOptions = () => {
  const [availableVoices, setAvailableVoices] = useState<SpeechSynthesisVoice[]>([]);
  const [selectedVoice, setSelectedVoice] = useState<string>('');
  const [rate, setRate] = useState(1);
  const [pitch, setPitch] = useState(1);
  const [volume, setVolume] = useState(0.75);
  
  // Load available voices and set default
  useEffect(() => {
    if (typeof window === 'undefined' || !window.speechSynthesis) return;
    
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices() || [];
      setAvailableVoices(voices);
      
      // Set a default voice (preferably English)
      if (voices.length > 0) {
        const englishVoice = voices.find(voice => voice.lang.includes('en-'));
        setSelectedVoice(englishVoice?.name || voices[0].name);
      }
    };
    
    // Handle voices loaded event
    if (typeof speechSynthesis !== 'undefined' && speechSynthesis.onvoiceschanged !== undefined) {
      speechSynthesis.onvoiceschanged = loadVoices;
    }
    
    loadVoices(); // Initial load for browsers that don't fire onvoiceschanged
  }, []);
  
  return {
    availableVoices,
    selectedVoice,
    setSelectedVoice,
    rate,
    setRate,
    pitch, 
    setPitch,
    volume,
    setVolume,
  };
};

export default useVoiceOptions;
